<template>
    <table-template :queryParams="queryParams" actionUrl="/dbtCard/findWithdrawMoneyList.action"
                    ref="withdrawalManager">
        <template slot="search">
            <el-select @change="$refs['withdrawalManager'].search()" clearable placeholder="请选择审核状态"
                       v-model="queryParams.status">
                <el-option :value="1" label="待审核"></el-option>
                <el-option :value="2" label="审核通过"></el-option>
                <el-option :value="3" label="审核不通过"></el-option>
            </el-select>
            <el-select @change="$refs['withdrawalManager'].search()" clearable placeholder="请选择支付类型"
                       v-model="queryParams.payStatus">
                <el-option :value="1" label="提现成功"></el-option>
                <el-option :value="2" label="提现失败"></el-option>
                <el-option :value="3" label="提现正在处理"></el-option>
            </el-select>

            <el-date-picker
                    @change="onWithDrawalTimeChanged"
                    clearable
                    end-placeholder="提现时间截止"
                    range-separator="至"
                    start-placeholder="提现时间开始"
                    style="margin-left: 10px;"
                    type="datetimerange"
                    v-model="withDrawalTimeSearch">
            </el-date-picker>

            <el-input placeholder="昵称/手机号/订单号" style="margin-left: 10px;width: 200px;"
                      v-model="queryParams.keyword"></el-input>
            <el-button @click="$refs['withdrawalManager'].search()" style="margin-left: 10px;" type="primary">搜索
            </el-button>
            <el-button @click="exportWithdrawMoney()" style="margin-left: 10px" type="danger">导出</el-button>
        </template>
        <template slot="item">
            <el-table-column
                    label="提现单号"
                    prop="withdrawNumber">
            </el-table-column>
            <el-table-column
                    label="昵称"
                    prop="nickname">
            </el-table-column>
            <el-table-column
                    label="账号"
                    prop="phone">
            </el-table-column>
            <el-table-column
                    label="提现方式">
              <template scope="scope">

                {{scope.row.withdrawType| payTypeFilter}}
              </template>
            </el-table-column>
            <el-table-column
                    label="提现账户">
                <template scope="scope">

                    <span v-if="scope.row.withdrawType === 2">
                        {{scope.row.personName}} - {{scope.row.openId}}
                    </span>
                    <span v-else-if="scope.row.withdrawType === 3">
                        {{scope.row.personName}} - {{scope.row.alipayPhone}}
                    </span>
                  <span v-else-if="scope.row.withdrawType === 4">
                        {{scope.row.personName}} - {{scope.row.bankNo}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="金额"
                    prop="money">
            </el-table-column>
            <el-table-column
                    label="手续费"
                    prop="serviceCharge">
            </el-table-column>
            <el-table-column
                    label="审核状态">
                <template scope="scope">
                    <span v-bind:style="{color:getStatusColor(scope.row.status)}">{{scope.row.status | statusFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="支付状态">
                <template scope="scope">
                    <span v-bind:style="{color:getStatusColor(scope.row.payStatus)}" v-if="scope.row.status!=3 ">{{scope.row.payStatus | payStatusFilter}}</span>
                    <span v-bind:style="{color:getStatusColor(scope.row.payStatus)}" v-else>无需支付</span>
                </template>
            </el-table-column>

            <el-table-column
                    label="提现时间">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    label="操作">
                <template scope="scope">
                    <el-button :confirm-data="{id:scope.row.id,status:2}" @onConfirm="$refs['withdrawalManager'].loadList()" confirm-text="确定审核通过？" requestUrl="dbtCard/changeWithdrawMoneyStatus.action"
                               type="text"
                               v-confirm
                               v-if="scope.row.status==1">通过
                    </el-button>
                    <el-button :confirm-data="{id:scope.row.id,status:3}" @onConfirm="$refs['withdrawalManager'].loadList()" confirm-text="确定审核不通过？" requestUrl="dbtCard/changeWithdrawMoneyStatus.action"
                               type="text"
                               v-confirm
                               v-if="scope.row.status==1">不通过
                    </el-button>
                </template>
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import TableTemplate from '@/components/TableTemplate'

export default {
  name: 'opening-card-record',
  extends: BasicPager,
  data () {
    return {
      withDrawalTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    statusFilter (value) {
      // eslint-disable-next-line camelcase
      let filter_value = '暂无'
      switch (value) {
        case 1:// 待审核
          filter_value = '待审核'
          break
        case 2:// 审核通过
          filter_value = '审核通过'
          break
        case 3:// 审核不通过
          filter_value = '审核不通过'
          break
      }
      return filter_value
    },
    payTypeFilter (value) {
      let filterValue = '状态不明确'
      switch (value) {
        case 2:
          filterValue = '微信到零钱'
          break
        case 3:
          filterValue = '支付宝'
          break
        case 4:
          filterValue = '微信到银行'
          break
      }
      return filterValue
    },
    payStatusFilter (value) {
      let filter_value = '暂无'
      // 支付状态:1-提现成功；2-提现失败;3-提现正在处理
      switch (value) {
        case 1:// 审核中
          filter_value = '提现成功'
          break
        case 2:// 审核通过
          filter_value = '提现失败'
          break
        case 3:// 审核失败
          filter_value = '提现正在处理'
          break
      }
      return filter_value
    }
  },
  methods: {
    onWithDrawalTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.withDrawalTimeSearchStart = null
        this.queryParams.withDrawalTimeSearchEnd = null
        this.$refs['withdrawalManager'].search()
        return
      }
      this.queryParams.withDrawalTimeSearchStart = datetime[0].getTime()
      this.queryParams.withDrawalTimeSearchEnd = datetime[1].getTime()
      this.$refs['withdrawalManager'].search()
    },
    getStatusColor (status) {
      let color = ''
      switch (status) {
        case 3:// 审核不通过
          color = '#F56C6C'
          break
        case 2:// 审核通过
          color = '#00CC00'
          break
        default:// 待审核;
          color = '#E6A23C'
      }
      return color
    },
    exportWithdrawMoney: function () {
      let _this = this

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      let dataStr = '&channelId=' + id
      if (this.queryParams.status) {
        dataStr += '&status=' + this.queryParams.status
      }
      if (this.queryParams.payStatus) {
        dataStr += '&payStatus=' + this.queryParams.payStatus
      }

      if (this.queryParams.withDrawalTimeSearchStart) {
        dataStr += '&withDrawalTimeSearchStart=' + this.queryParams.withDrawalTimeSearchStart
      }

      if (this.queryParams.withDrawalTimeSearchEnd) {
        dataStr += '&withDrawalTimeSearchEnd=' + this.queryParams.withDrawalTimeSearchEnd
      }

      if (this.queryParams.keyword) {
        dataStr += '&keyword=' + this.queryParams.keyword
      }

      window.location.href = Config.baseUrl + '/dbtCard/exportWithdrawMoney.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    }
  }
}
</script>
